import React, { useState } from "react";


export default function AIMl() {
  const [processOpen, setProcessOpen] = useState(0); // index of open process item
  const [faqOpen, setFaqOpen] = useState(0); // index of open FAQ item

  const toggleProcess = (i) => setProcessOpen((prev) => (prev === i ? -1 : i));
  const toggleFaq = (i) => setFaqOpen((prev) => (prev === i ? -1 : i));

  return (
    <div className="page_wrapper">
      {/* Minimal page head-equivalents are omitted here; import CSS like bootstrap and your style.css in index.html */}

      <main className="page_content">
        {/* Page Banner */}
        <section
          className="page_banner_section text-center"
          style={{ backgroundImage: "url('assets/images/shapes/bg_pattern_3.svg')",marginTop: '90px' }}
        >
          <div className="container">
            <div className="heading_focus_text text-white">
              Service
              <span className="badge bg-secondary">Details </span>
            </div>
            <h1 className="page_title mb-0 text-white">AI / Machine Learning Solutions </h1>
          </div>
        </section>

        {/* Service Details Section */}
        <section className="service_details_section section_space bg-light">
          <div className="container">
            <div className="details_item_image position-relative">
              <img
                src="assets/images/service-details/AI _ Machine Learning Solutions.jpg"
                alt="Dedicated Developer Service"
                style={{ width: "100%", display: "block" }}
              />
            </div>

            <h2 className="details_item_title">AI & Machine Learning Solutions</h2>
            <p>Embed intelligence in your products and automate decision-making at scale.</p>
            <p>
              We build and deploy predictive models, AI agents, recommendation systems, and NLP
              pipelines tailored to your use case—securely and ethically.
            </p>

            <h3 className="details_item_info_title">Service Process</h3>
            <div className="row mb-5 align-items-center justify-content-lg-between">
              <div className="col-lg-6">
                <div className="accordion" id="service_process_faq">
                  {[
                    {
                      title: "01. Data Discovery",
                      body: "Explore and clean datasets to ensure readiness.",
                    },
                    {
                      title: "02. Model Design",
                      body: "Select algorithms, validate features, and define KPIs.",
                    },
                    {
                      title: "03. Training & Tuning",
                      body: "Hyperparameter optimization and cross-validation.",
                    },
                    {
                      title: "04. Deployment",
                      body: "Serve via APIs or embed in product workflows.",
                    },
                  ].map((item, i) => (
                    <div className="accordion-item" key={i}>
                      <button
                        className={`accordion-button ${processOpen === i ? "" : "collapsed"}`}
                        onClick={() => toggleProcess(i)}
                        aria-expanded={processOpen === i}
                        aria-controls={`process-${i}`}
                        style={{ cursor: "pointer", width: "100%", textAlign: "left" }}
                      >
                        {item.title}
                      </button>

                      <div
                        id={`process-${i}`}
                        className={`accordion-collapse collapse ${processOpen === i ? "show" : ""}`}
                      >
                        <div className="accordion-body">
                          <p className="m-0">{item.body}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-lg-5">
                <ul className="content_layer_group unordered_list_block text-center" style={{ listStyle: "none", paddingLeft: 0 }}>
                  {[
                    "Data Discovery",
                    "Model Design",
                    "Training & Tuning",
                    "Deployment",
                  ].map((t, i) => (
                    <li
                      key={i}
                      className={`accordion-button ${processOpen === i ? "" : "collapsed"}`}
                      role="button"
                      onClick={() => toggleProcess(i)}
                      style={{ cursor: "pointer", padding: "12px 8px" }}
                    >
                      <span>{t}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <h3 className="details_item_info_title">Service Inclusions</h3>

            <div className="row mb-4">
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block" style={{ listStyle: "none", paddingLeft: 0 }}>
                  <li style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                    {/* brain SVG */}
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-2">
                      <path d="M12 2C13.1046 2 14 2.89543 14 4V5H18C19.1046 5 20 5.89543 20 7V10H21C22.1046 10 23 10.8954 23 12V13" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span>AI Agent Development</span>
                  </li>
                  <li style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-2">
                      <rect x="3" y="3" width="18" height="6" rx="1" stroke="currentColor" strokeWidth="1.2" />
                      <rect x="3" y="15" width="18" height="6" rx="1" stroke="currentColor" strokeWidth="1.2" />
                    </svg>
                    <span>Data Preparation &amp; Cleaning</span>
                  </li>
                </ul>
              </div>

              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block" style={{ listStyle: "none", paddingLeft: 0 }}>
                  <li style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-2">
                      <path d="M4 7H20" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                      <path d="M6 12H18" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                      <path d="M8 17H16" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                    </svg>
                    <span>Recommendation &amp; Forecasting Models</span>
                  </li>
                  <li style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-2">
                      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.2" />
                      <path d="M19 12c0 3.866-3.582 7-8 7" stroke="currentColor" strokeWidth="1.2" />
                    </svg>
                    <span>NLP Pipelines (chatbots, translation, summaries)</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services/machine learning.jpg" alt="Developer Writing Code" style={{ width: "100%" }} />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services/artificial intelligence brain.jpg" alt="Team Collaboration" style={{ width: "100%" }} />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services/neural network.jpg" alt="Progress Reporting" style={{ width: "100%" }} />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq_section section_decoration">
          <div className="container">
            <div className="heading_block text-center">
              <div
                className="heading_focus_text has_underline d-inline-flex"
                style={{ backgroundImage: "url('assets/images/shapes/shape_title_under_line.svg')" }}
              >
                F.A.Q.
              </div>
              <h2 className="heading_text mb-0">
                Need a <mark>Support?</mark>
              </h2>
            </div>

            <div className="faq_accordion accordion" id="faq_accordion">
              {[
                {
                  q: "Q. Is there a minimum contract or hourly block?",
                  a: "No long-term lock-in. Billing is month-to-month with a 40-hour minimum. Unused hours roll forward for 30 days, so you never lose paid time.",
                },
                {
                  q: "Q. Can I scale the team up or down fast?",
                  a: "Yes. Add or pause assistants with 24-hour notice—perfect for seasonal peaks or project sprints. Your account manager handles onboarding and off-boarding paperwork.",
                },
                {
                  q: "Q. What if I’m unhappy with task quality?",
                  a: "You get a dedicated QA lead who scores work daily. If accuracy ever drops below 98 %, we retrain or replace the VA at no extra cost within one business day.",
                },
                {
                  q: "Q. Do you work in my time zone?",
                  a: "We staff assistants in US and APAC zones and can provide blended coverage for 24/7 support. Just tell us your preferred hours during onboarding.",
                },
                {
                  q: "Q. How is communication handled?",
                  a: "Your VA is available in Slack, Teams or email—your choice. Weekly 15-minute stand-ups and a live dashboard keep you updated on task status and KPIs.",
                },
              ].map((item, i) => (
                <div className="accordion-item" key={i}>
                  <button
                    className={`accordion-button ${faqOpen === i ? "" : "collapsed"}`}
                    onClick={() => toggleFaq(i)}
                    aria-expanded={faqOpen === i}
                    aria-controls={`faq-${i}`}
                    style={{ cursor: "pointer", width: "100%", textAlign: "left" }}
                  >
                    {item.q}
                  </button>

                  <div id={`faq-${i}`} className={`accordion-collapse collapse ${faqOpen === i ? "show" : ""}`}>
                    <div className="accordion-body">
                      <div className="text_a">A.</div>
                      <p>{item.a}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="decoration_item shape_image_1">
            <img src="assets/images/shapes/shape_space_4.svg" alt=" Shape" />
          </div>
        </section>

        {/* Call To Action */}
        <section className="calltoaction_section parallaxie" style={{ backgroundImage: "url('assets/images/backgrounds/staffing.jpg')" }}>
          <div className="container text-center">
            <div className="heading_block text-white">
              <h2 className="heading_text">Ready to Work, Let's Chat</h2>
              <p className="heading_description mb-0">
                Our team of experts is ready to collaborate with you every step of the way, from initial consultation to implementation.
              </p>
            </div>
            <a className="btn btn-primary" href="contact.php">
              <span className="btn_label" data-text="Contact Us Today!">Contact Us Today!</span>
              <span className="btn_icon">
                {/* arrow svg */}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 17L17 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M7 7H17V17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}
